if (!customElements.get('yotpo-gallery-loader')) {
  const interactionEvents = ['scroll', 'pointerdown', 'keydown', 'touchstart', 'wheel'];

  function afterFirstInteraction(callback) {
    if (window.scrollY > 0) {
      callback();
      return;
    }

    const onInteraction = () => {
      interactionEvents.forEach((type) => window.removeEventListener(type, onInteraction));
      callback();
    };
    interactionEvents.forEach((type) => window.addEventListener(type, onInteraction, { passive: true }));
  }

  customElements.define(
    'yotpo-gallery-loader',
    class YotpoGalleryLoader extends HTMLElement {
      connectedCallback() {
        this.mount = document.getElementById(this.dataset.mount);
        if (!this.mount || this.mount.classList.contains('yotpo')) return;

        if (!('IntersectionObserver' in window)) {
          this.activate();
          return;
        }

        this.observer = new IntersectionObserver(
          (entries) => {
            const entry = entries.find((item) => item.isIntersecting);
            if (!entry) return;
            this.observer.disconnect();

            if (entry.boundingClientRect.top < window.innerHeight) {
              this.activate();
            } else {
              afterFirstInteraction(() => this.activate());
            }
          },
          { rootMargin: '800px 0px' }
        );
        this.observer.observe(this);
      }

      disconnectedCallback() {
        this.observer?.disconnect();
        clearInterval(this.initTimer);
      }

      activate() {
        if (this.activated) return;
        this.activated = true;
        this.mount.classList.add('yotpo');

        let attempts = 0;
        const init = () => {
          if (this.mount.hasAttribute('data-yotpo-element-id') || attempts++ > 60) {
            clearInterval(this.initTimer);
            return;
          }
          if (window.yotpo?.initialized && typeof window.yotpo.initWidgetsV2 === 'function') {
            clearInterval(this.initTimer);
            window.yotpo.initWidgetsV2();
          }
        };

        this.initTimer = setInterval(init, 500);
        init();
      }
    }
  );
}
